const state = {
  isLogin:false,
  userInfo:{},
  showGoodAdv:false,
}
const getters = {
  
}
const mutations = {
  Change_Login_State(state,isLogin){
    state.isLogin = isLogin
  },
  Update_User_Info(state,userInfo){
    state.userInfo = userInfo
  },
  Change_Show_Good_Adv(state,isShow){
    state.showGoodAdv = isShow
  }
}
const actions = {
 
}
export default {
  state, 
  getters,
  mutations,
  actions
}
